export default "__VITE_ASSET__662d1746__"